export default __webpack_public_path__ + "assets/copy_big.png";